import { createBootstrap } from "../../bootstrap";

export default createBootstrap("recipients", "achCompanies", "institution");
